import React from "react";
import Provider from "./provider";
// import CacheBuster from "./CacheBuster";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.css';
export const wrapRootElement = Provider;
